$(document).ready(function () {
    $('#mobile-menu-toggle').click(function () {
        $('.nav-menu').toggleClass('open');
        $('.hamburger-icon').toggleClass('open');

        if ($('.nav-menu').hasClass('open')) {
            $(".modal-overlay").attr("aria-hidden", "false");
            $(".modal-overlay").addClass("nav-overlay");
        } else {
            $(".modal-overlay").attr("aria-hidden", "true");
            $(".modal-overlay").removeClass("nav-overlay");
        }
    });

    $(window).on('resize', function () {
        if (window.innerWidth > 992 && $('.nav-menu').hasClass('open')) {
            closeNavMenu();
        }
    });
});

function closeNavMenu() {
    $('.nav-menu').removeClass('open');
    $('.hamburger-icon').removeClass('open');
    $(".modal-overlay").attr("aria-hidden", "true");
    $(".modal-overlay").removeClass("nav-overlay");
}

window.closeNavMenu = closeNavMenu;